export default __webpack_public_path__ + "media/Hero_right_desktop.5b9daf6a388535d5a300f2ec5c86c742.svg";